import library from './library'

export default (dataService, domain, tokenStorage, authService, libraryServicesApi) => {
    const lib = library(domain, tokenStorage, libraryServicesApi)

    const api = dataService.create({
        baseURL: lib.getServerDomain(),
        headers: {
            common: {
                Authorization: lib.getAuthorizationHeader(),
            },
        },
    })

    api.interceptors.request.use(
        (config) => {
            if (config.headers.common['Authorization'] !== lib.getAuthorizationHeader()) {
                config.headers.common['Authorization'] = lib.getAuthorizationHeader()
            }

            return config
        },
        function (error) {
            return Promise.reject(error)
        }
    )

    api.interceptors.response.use(
        (response) => response,
        (error) => {
            const {
                response: { status, data },
            } = error
            switch (status) {
                case 401:
                    authService.refreshAccessToken()
                    break
                case 403:
                    if (lib.userHasntAcceptedTheTermsOfUser(data.data)) {
                        lib.redirectToTermsOfUse()
                    } else if (lib.userHasPasswordExpired(data.data)) {
                        lib.redirectToUpdatePassword(data.data.token)
                    } else {
                        lib.redirectToErrorPage(status)
                    }
                    break
                default:
                    lib.redirectToErrorPage(status)
                    break
            }

            return Promise.reject(error)
        }
    )

    return api
}
